/**
 * Motion tokens for hand-written transitions, where macaw's `transition`
 * sprinkle (all 300ms ease-in-out) is too slow and too broad. Values follow
 * the common design-system defaults: colour changes settle in ~150ms on
 * the Material "standard" curve, which starts quickly and decelerates.
 */
export const motion = {
  /** Hover and press colour changes. */
  colorMs: 150,
  standardEasing: "cubic-bezier(0.4, 0, 0.2, 1)",
} as const;

export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/** A `transition` value for the given properties, or none under reduced motion. */
export const colorTransition = (...properties: string[]) =>
  prefersReducedMotion()
    ? undefined
    : properties
        .map(p => `${p} ${motion.colorMs}ms ${motion.standardEasing}`)
        .join(", ");
